<template>
  <div class="claim-submission-dialog"> 
    <div v-if="claimStatusEnumeration == 1">
      <h3>
        Are you sure you want to submit your claim?<br>Missing or incomplete information may be cause for claim denial.
      </h3>
      <b-button class="btn dn-btn-large btn-large" @click="ConfirmClaim()">Submit</b-button>
      <b-button class="btn btn-inverse btn-large" @click="ResetClaimStatus">Cancel</b-button>
    </div> 
    <!-- Show when processing -->
    <div v-if="claimStatusEnumeration == 2">  
      <div class="loader" />
    </div> 
    <!-- Show on success -->
    <div v-if="claimStatusEnumeration == 3">
      <h3 v-if="this.$parent.claimDto.ClaimType !== 'ExtraParts'">
        The following claim(s) were created:
      </h3>
      <div v-if="this.$parent.claimDto.ClaimType !== 'ExtraParts'">
        <div v-for="(claimReference, claimResults) in this.$parent.claimPlacementResultDto" :key="claimResults">
          <ul>
            <li>{{ claimReference.ClaimReferenceNumber }}</li>
          </ul>
        </div>
      </div>
      <p v-if="this.$parent.claimDto.ClaimType === 'ExtraParts'">
        Your claim has been submitted and you should receive an email shortly.
      </p>
      <b-button class="btn dn-btn-large btn-large" @click="GoToClaimsIndex">
        Ok
      </b-button>
    </div> 
    <!-- Show if there are any errors -->
    <div v-if="claimStatusEnumeration == 4">
      <h3>The claim submission failed with the following errors:</h3>
      <div v-for="(claimReference, claimResults) in this.$parent.claimPlacementResultDto" :key="claimResults">
        <ul v-for="(currentError, claimErrors) in claimReference.Errors" :key="claimErrors">
          <li>{{ currentError }}</li>
        </ul>
      </div>
    </div> 
  </div>
</template>

<script>
  export default {
    props: {
      claimStatusEnumeration: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      GoToClaimsIndex(){
        this.$emit("GoToClaimsIndex");
      },
      ConfirmClaim(){
        this.$emit("ConfirmClaim");
      },
      ResetClaimStatus(){
        this.$emit("ResetClaimSubmissionStatus");
      },
    }
  }
</script>
<style>
 .claim-submission-dialog{
     border-top: 1px solid #000;
 }
 .claim-submission-dialog * {
     padding-top: 10px;
     padding-bottom: 10px;
 }
</style>